import { IMonthlyReccurency, IRecurrencyData } from '../../../campaigns/src/model';
import { ICronExpressions } from '../../../campaigns/src/services/model';

export interface IWeeklyCronExpressionParams {
	hour: number;
	minute: number;
	weekdays: string[];
}
export interface IMonthlyCronExpressionParams {
	hour: number;
	minute: number;
	recurrencies: IMonthlyReccurency[];
}

export enum RecurrencyTypeEnum {
	DailyWeekly = 'DailyWeekly',
	Monthly = 'Monthly',
}
export enum MonthlyRecurrencyTypeEnum {
	Day = 'Day',
	Date = 'Date',
}

export interface ICronExpressionObject {
	second: string;
	minute: string;
	hour: string;
	dom: string; // day of month
	month: string;
	dow: string; // day of week
	year: string;
}

export const generateCronExpressionFromObject = (obj: ICronExpressionObject) => {
	return `${obj.second} ${obj.minute} ${obj.hour} ${obj.dom} ${obj.month} ${obj.dow} ${obj.year}`;
};

export const generateWeeklyCronExpression = ({ hour, minute, weekdays }: IWeeklyCronExpressionParams): ICronExpressions[] => {
	// disablle alphabetical ordering lint just to see the order properly
	/* tslint:disable */
	const obj: ICronExpressionObject = {
		second: '0',
		minute: minute + '',
		hour: hour + '',
		dom: '?',
		month: '*',
		dow: weekdays.join(',') || '?',
		year: '*',
	};
	/* tslint:enalble */

	return [
		{
			Expression: generateCronExpressionFromObject(obj),
		},
	];
};

export const generateMonthlyCronExpression = ({ hour, minute, recurrencies }: IMonthlyCronExpressionParams): ICronExpressions[] => {
	return recurrencies
		.filter((item) => item[MonthlyRecurrencyTypeEnum.Day] || item[MonthlyRecurrencyTypeEnum.Date])
		.map((item) => {
			let date = '?',
				weekday = '?';

			const dayRec = item[MonthlyRecurrencyTypeEnum.Day];
			const dateRec = item[MonthlyRecurrencyTypeEnum.Date];

			if (dateRec) {
				date = dateRec.repeatEvery.toString();
			} else if (dayRec) {
				let day = dayRec.day;

				weekday = day + '#' + dayRec.repeatEvery;
			} else {
				throw new Error('this monthly recurrencyType does not exist!');
			}

			var obj: ICronExpressionObject = {
				second: '0',
				minute: minute + '',
				hour: hour + '',
				dom: date,
				month: '*',
				dow: weekday,
				year: '*',
			};

			return {
				Expression: generateCronExpressionFromObject(obj),
			};
		});
};

export const generateRecurrencySettingsFromCronExpressions = (exprs: string[]): IRecurrencyData => {
	// var exprs = ['0 2 15 ? * 1,2,3 *'];
	// var exprs = ['0 0 15 1 * ? *', '0 0 15 ? * 1#2 *'];

	var recSettings: IRecurrencyData = {
		hour: 0,
		minute: 0,
		[RecurrencyTypeEnum.DailyWeekly]: null,
		[RecurrencyTypeEnum.Monthly]: null,
	};

	if (!exprs || !exprs.length) {
		return recSettings;
	}

	let monthlyData: IMonthlyReccurency[] = [];

	exprs.forEach((expr) => {
		const splitExpr = expr.split(' ');
		const weekdaysHash = splitExpr[5].split('#');
		const weekdays = splitExpr[5].split(',');

		recSettings.hour = parseInt(splitExpr[2]);
		recSettings.minute = parseInt(splitExpr[1]);

		if (weekdaysHash.length === 1 && splitExpr[5] !== '?') {
			recSettings[RecurrencyTypeEnum.DailyWeekly] = weekdays;
		} else if (weekdaysHash.length > 1 || splitExpr[5] === '?') {
			if (splitExpr[5] === '?') {
				const repeatEvery = parseInt(splitExpr[3]);
				if (!repeatEvery) return;
				monthlyData.push({
					[MonthlyRecurrencyTypeEnum.Day]: null,
					[MonthlyRecurrencyTypeEnum.Date]: {
						repeatEvery,
					},
				});
			} else if (weekdaysHash.length > 1) {
				let day = parseInt(weekdaysHash[0]);
				const repeatEvery = parseInt(weekdaysHash[1]);

				if (!day || !repeatEvery) return;

				monthlyData.push({
					[MonthlyRecurrencyTypeEnum.Date]: null,
					[MonthlyRecurrencyTypeEnum.Day]: {
						day,
						repeatEvery,
					},
				});
			} else {
				throw new Error('Unknown monthly cron expression, expression was not created via app!');
			}
		} else {
			throw new Error('Unknown cron expression, expression was not created via app!');
		}
	});

	monthlyData.length && (recSettings[RecurrencyTypeEnum.Monthly] = monthlyData);

	return recSettings;
};
